<template>
  <div>
    <CRow class="mb-3">
      <CCol sm="6">
        <label>{{ $pgettext('tag_definitions.form', 'Min Date') }}</label>
        <CInput
            type="date"
            v-model="config.min_date"
        />
      </CCol>
      <CCol sm="6">
        <label>{{ $pgettext('tag_definitions.form', 'Max Date') }}</label>
        <CInput
            type="date"
            v-model="config.max_date"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "DateInputConfig",
  data() {
    return {
      config: {
        type: 'date',
        min_date: null,
        max_date: null
      }
    }
  },
  methods: {
    onReset(data) {
      this.config = {
        type: 'date',
        min_date: null,
        max_date: null,
        ...data
      }
    },
    onSave() {
      return this.config
    }
  }
}
</script>
